import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slug-generator"
export default class extends Controller {
  static targets = ["name", "slug"]

  connect() {
    this.update()
  }

  update() {
    const name = this.nameTarget.value
    this.slugTarget.value = name.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_oftentimes/g, "")
  }
}
